import {faExclamationCircle} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {warning, exclamationIcon} from './warning.module.scss'

type Props = {
  text: string
  className?: string
}

export default function Warning(props: Props) {
  const {text, className} = props
  const newClassName = [warning, ...maybeToList(className)].join(' ')

  return (
    <div className={newClassName}>
      <FontAwesomeIcon className={exclamationIcon} icon={faExclamationCircle} />
      <span>{text}</span>
    </div>
  )
}

function maybeToList<A>(a?: A | null): Array<A> {
  return a === null || a === undefined ? [] : [a]
}
